module.exports = __webpack_public_path__ + "static/media/business-img2.f42206ec.svg";